import request from "@/utils/request";

export function login(data: any) {
  return request({
    url: "/sysUser/login",
    method: "post",
    data,
  });
}
// 重置密码
export function resetPassword(data: any) {
  return request({
    url: "/sysUser/updatePass",
    method: "post",
    data,
  });
}
// 退出登录
export function loginOut(data: any) {
  return request({
    url: "/sysUser/logout",
    method: "post",
    data,
  });
}
// 包配置列表
export function sysConfigList(data: any) {
  return request({
    url: "/sysData/configListL2",
    method: "get",
    params: data,
  });
}
// 数据列表
export function sysDailyList(data: any) {
  return request({
    url: "/sysData/dailyListL2",
    method: "get",
    params: data,
  });
}
// 投放数据列表
export function sysNovelUserOrderList(data: any) {
  return request({
    url: "/sysNovelUserOrder/queryList",
    method: "get",
    params: data,
  });
}
// 投放数据修改
export function sysNovelUserOrderSave(data: any) {
  return request({
    url: "/sysNovelUserOrder/save",
    method: "post",
    data,
  });
}
// 应用列表
export function sysNovelConfigList(data: any) {
  return request({
    url: "/sysNovelConfig/queryListAll",
    method: "get",
    params: data,
  });
}
// 小说数据
export function sysNovelUserOrderDataList(data: any) {
  return request({
    url: "/sysNovelUserOrder/data/queryList",
    method: "get",
    params: data,
  });
}
// 首页数据
export function sysNovelUserOrderHome(data: any) {
  return request({
    url: "/sysNovelUserOrder/home/queryList",
    method: "get",
    params: data,
  });
}
// 首页数据列表
export function sysNovelUserOrderHomeListBottom(data: any) {
  return request({
    url: "/sysNovelUserOrder/home/queryListBottom",
    method: "get",
    params: data,
  });
}
// 保存数据
export function sysNovelConfigSave(data: any) {
  return request({
    url: "/sysNovelConfig/save",
    method: "post",
    data,
  });
}
// 删除数据
export function sysNovelConfigDel(data: any) {
  return request({
    url: "/sysNovelConfig/del",
    method: "post",
    data,
  });
}
// 获取facebook business账户数据
export function businessPage(data: any) {
  return request({
    url: "/oauth/facebook/business/Page",
    method: "get",
    params: data,
  });
}
// 获取统计数据
export function businessCount(data: any) {
  return request({
    url: "/oauth/facebook/business/count",
    method: "get",
    params: data,
  });
}
// 获取订单汇总列表
export function ordersList(data: any) {
  return request({
    url: "/sysData/area/orders",
    method: "get",
    params: data,
  });
}
// 获取新用户数据列表
export function newUserList(data: any) {
  return request({
    url: "/sysData/area/newUserList",
    method: "get",
    params: data,
  });
}
//今日阅读数据
export function historyToDay(data: any) {
  return request({
    url: "/sysData/area/historyToDay",
    method: "get",
    params: data,
  });
}
//昨日阅读数据
export function historyYesToDay(data: any) {
  return request({
    url: "/sysData/area/historyYesToDay",
    method: "get",
    params: data,
  });
}
// 订单监控
export function orderInTime(data: any) {
  return request({
    url: "/sysData/area/orderInTime",
    method: "get",
    params: data,
  });
}
// 订单监控列表
export function orderInTimeList(data: any) {
  return request({
    url: "/sysData/area/orderInTimeList",
    method: "get",
    params: data,
  });
}
// 订阅监控列表
export function orderSubCancelList(data: any) {
  return request({
    url: "/sysData/area/orderSubCancelList",
    method: "get",
    params: data,
  });
}
// 订阅监控轮训
export function orderSubCancel(data: any) {
  return request({
    url: "/sysData/area/orderSubCancel",
    method: "get",
    params: data,
  });
}

// 退款监控列表
export function orderRefundList(data: any) {
  return request({
    url: "/sysData/area/orderRefundList",
    method: "get",
    params: data,
  });
}
// 退款监控轮训
export function orderRefund(data: any) {
  return request({
    url: "/sysData/area/orderRefund",
    method: "get",
    params: data,
  });
}
// 广告列表数据
export function admDateList(data: any) {
  return request({
    url: "/sysData/admDateList",
    method: "get",
    params: data,
  });
}
// 广告配置列表
export function configAdmList(data: any) {
  return request({
    url: "/sysData/configAdmListL2",
    method: "get",
    params: data,
  });
}
// 广告配置列表详情
export function admDateListAdUnit(data: any) {
  return request({
    url: "/sysData/admDateListAdUnit",
    method: "get",
    params: data,
  });
}
// h5广告列表
export function h5AdmDateList(data: any) {
  return request({
    url: "/sysData/adsDateList",
    method: "get",
    params: data,
  });
}
// H5广告列表详情
export function h5AdmDateListAdUnit(data: any) {
  return request({
    url: "/sysData/adsDateListAdUnit",
    method: "get",
    params: data,
  });
}
// h5广告列表
export function h5SelfAdmDateList(data: any) {
  return request({
    url: "/sysData/adsDateListSelf",
    method: "get",
    params: data,
  });
}
// H5广告列表详情
export function h5SelfAdmDateListAdUnit(data: any) {
  return request({
    url: "/sysData/adsDateListAdUnitSelf",
    method: "get",
    params: data,
  });
}
// 通道列表
export function channelList(data: any) {
  return request({
    url: "/channel/query",
    method: "get",
    params: data,
  });
}
// 通道广告列表
export function channelAdmDateList(data: any) {
  return request({
    url: "/channel/queryAds",
    method: "get",
    params: data,
  });
}
// 通道账号列表
export function channelAccountList(data: any) {
  return request({
    url: "/channel/queryAccount",
    method: "get",
  });
}
// 通道域名列表
export function channelDomainList(data: any) {
  return request({
    url: "/channel/queryHosts",
    method: "get",
    params: data,
  });
}
// 通道广告列表创建
export function channelAdmDateCreate(data: any) {
  return request({
    url: "/channel/saveAds",
    method: "post",
    data,
  });
}
// 通道账号创建
export function channelAccountCreate(data: any) {
  return request({
    url: "/channel/saveAccount",
    method: "post",
    data,
  });
}
// 通道域名创建
export function channelDomainCreate(data: any) {
  return request({
    url: "/channel/saveHosts",
    method: "post",
    data,
  });
}
// 通道域名删除
export function channelDomainDel(data: any) {
  return request({
    url: "/channel/delHosts",
    method: "post",
    data,
  });
}
// 通道创建
export function channelSave(data: any) {
  return request({
    url: "/channel/save",
    method: "post",
    data,
  });
}
// 自营H5广告列表配置
export function h5SelfAdmConfigList(data: any) {
  return request({
    url: "/sysData/adsConfigSelf",
    method: "get",
    params: data,
  });
}

// 综合H5广告列表
export function allH5AdmDateList(data: any) {
  return request({
    url: "/ads/queryAdsApp",
    method: "get",
    params: data,
  });
}
// 广告源列表
export function adsSourceList(data: any) {
  return request({
    url: "/ads/query",
    method: "get",
    params: data,
  });
}
// 添加广告源
export function adsSourceCreate(data: any) {
  return request({
    url: "/ads/saveUrl",
    method: "post",
    data,
  });
}
// 广告配置列表
export function adsConfigList(data: any) {
  return request({
    url: "/ads/queryGroup",
    method: "get",
    params: data,
  });
}
// 广告配置添加
export function adsConfigAdd(data: any) {
  return request({
    url: "/ads/saveGroup",
    method: "post",
    data,
  });
}
// 广告配置删除
export function adsConfigDel(data: any) {
  return request({
    url: "/ads/delUrl",
    method: "post",
    data,
  });
}
// 广告配置详情列表
export function adsConfigDetailList(data: any) {
  return request({
    url: "/ads/queryUrls",
    method: "get",
    params: data,
  });
}
// 广告列表详情
export function adsDetailList(data: any) {
  return request({
    url: "/ads/queryAdsAppInfo",
    method: "get",
    params: data,
  });
}
// 广告源删除
export function adsSourceDel(data: any) {
  return request({
    url: "/ads/delAdsUrl",
    method: "post",
    data,
  });
}
// 广告配置批量添加/ 
export function adsConfigSaveGroupList(data: any) {
  return request({
    url: "/ads/saveGroupList",
    method: "post",
    data,
  });
}
// 退款监控
export function dailyRefund(data: any) {
  return request({
    url: "/sysData/dailyRefund",
    method: "get",
    params: data,
  });
}
// 跳转配置
export function jumpConfig(data: any) {
  return request({
    url: "/jump/queryConfig",
    method: "get",
    params: data,
  });
}
//保存跳转配置
export function jumpConfigSave(data: any) {
  return request({
    url: "/jump/saveConfig",
    method: "post",
    data,
  });
}
// 获取自定义跳转配置
export function jumpConfigCtr(data: any) {
  return request({
    url: "/jump/queryCtr",
    method: "get",
    params: data,
  });
}
// 保存自定义跳转配置
export function jumpConfigCtrSave(data: any) {
  return request({
    url: "/jump/saveCtr",
    method: "post",
    data,
  });
}